import { useImmer } from 'use-immer'
import { Button } from 'reactstrap'
import { InputContainer } from 'components/ideal-core-ui'
import { PaginatedSelect } from 'components/common/PaginatedSelect'
import { toCompaniesSelect } from 'components/Companies/serializers'
import { makePostRequest } from 'utils/api'
import s from '../../DealsModal.scss'
import cn from 'classnames'

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  company: null
}

const AddContact = ({ selectKey, incrementKey }) => {
  const [contact, setContact] = useImmer(initialState)

  const changeNewContactProperty = (value, property) => {
    setContact(state => {
      state[property] = value
    })
  }

  const saveContact = async () => {
    try {
      const formData = new FormData()
      const { firstName, lastName, email, company, cellPhone, phone, phoneExt, fax } = contact
      const contactData = {
        ...(email ? { email } : {}),
        ...(firstName ? { firstName } : {}),
        ...(lastName ? { lastName } : {}),
        ...(company ? { companyId: company.value } : {}),
        ...(cellPhone ? { cellPhone } : {}),
        ...(phone ? { phone } : {}),
        ...(phoneExt ? { phoneExt } : {}),
        ...(fax ? { fax } : {})
      }

      formData.append('contactData', JSON.stringify(contactData))

      await makePostRequest('/v1/contacts', formData)
      incrementKey()
      setContact(initialState)
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  return (
    <>
      <InputContainer
        type="text"
        text={contact.firstName}
        classname={s.input}
        placeholder="*Contact First Name"
        cb={value => changeNewContactProperty(value, 'firstName')}
      />
      <InputContainer
        type="text"
        text={contact.lastName}
        classname={s.input}
        placeholder="*Contact Last Name"
        cb={value => changeNewContactProperty(value, 'lastName')}
      />
      <InputContainer
        type="text"
        text={contact.email}
        classname={s.input}
        placeholder="*Contact Email"
        cb={value => changeNewContactProperty(value, 'email')}
      />
      <PaginatedSelect
        url="/v1/companies"
        className={s.input}
        value={contact.company}
        onChange={value => changeNewContactProperty(value, 'company')}
        serializer={toCompaniesSelect}
        selectKey={selectKey}
      />
      <InputContainer
        type="text"
        text={contact.cellPhone}
        classname={s.input}
        placeholder="Cell Phone"
        cb={value => changeNewContactProperty(value, 'cellPhone')}
      />
      <InputContainer
        type="text"
        text={contact.phone}
        classname={s.input}
        placeholder="Office Phone"
        cb={value => changeNewContactProperty(value, 'phone')}
      />
      <InputContainer
        type="text"
        text={contact.phoneExt}
        classname={s.input}
        placeholder="Ext."
        cb={value => changeNewContactProperty(value, 'phoneExt')}
      />
      <InputContainer
        type="text"
        text={contact.fax}
        classname={s.input}
        placeholder="Fax"
        cb={value => changeNewContactProperty(value, 'fax')}
      />
      <Button
        disabled={!contact.firstName || !contact.lastName || !contact.email || !contact.company}
        className={cn(s.saveBtn, s.btnPosition)}
        onClick={saveContact}
      >
        Save Contact
      </Button>
    </>
  )
}

export default AddContact
